import { Image } from '@chakra-ui/image';
import React, { useState } from 'react';

import menuIcon from '../icons/menu.svg';
import menuIconActive from '../icons/menu_active.svg';
import { Container } from '../product-switcher.styled';

export const ProductSwitcherMenu = ({ isOpen }: { isOpen: boolean }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Container
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Image src={isHovered || isOpen ? menuIconActive : menuIcon} />
        </Container>
    );
};
